import { configNewsletter } from "@pub/config";
import {
  Newsletter as NewsletterDesignSystem,
  setMobileBannerHiddenCookie,
} from "@sphtech/dmg-design-system";
import React from "react";

const SUBSCRIBE_API = "/_plat/api/subscribe_newsletter";

export type AppNewsletterProps = Omit<
  React.ComponentProps<typeof NewsletterDesignSystem>,
  "onSubmit"
>;

const AppNewsletter: React.FC<AppNewsletterProps> = (props) => {
  const onSubmit = async (email: string, isChecked: boolean) => {
    try {
      const response = await fetch(SUBSCRIBE_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          marketingCheckbox: isChecked,
        }),
      });

      if (response.ok) {
        window.SPHMGTM.cmd.push(
          `send={"type":"event","category":"Newsletter","action":"signup","label":"/"}`,
        );
        setMobileBannerHiddenCookie(365);
        return {
          ok: true,
          message: "Thank you for subscribing.",
        };
      } else {
        console.error("Request failed, status:", response.status);
        if (response.status >= 400 && response.status < 500) {
          return {
            ok: false,
            message: "Invalid input, we could not process your request.",
          };
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
    return {
      ok: false,
      message:
        "An unexpected error occurred. Your request could not be processed at this time.",
    };
  };

  return (
    <NewsletterDesignSystem
      {...props}
      onSubmit={onSubmit}
      buttonVariant={configNewsletter.buttonVariant}
      hasTermsInConsent={configNewsletter.hasTermsInConsent}
      signUpText={configNewsletter.signUpText}
    />
  );
};

export default AppNewsletter;
